exports = module.exports = require("../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".acc-icon{will-change:transform;transition:transform .25s ease-out}.rotate{transform:rotate(180deg)}.header{margin:0;padding:0;text-align:left;font-size:.95rem;font-weight:600}body[dir=rtl] .rotate {\n  transform: rotate(-180deg);\n}body[dir=rtl] \n.header {\n  text-align: right;\n}\n", ""]);

// exports
